import { AxiosRequestConfig } from 'axios';
import axios, { ErrorMessage2 } from '../../../api';
import { endpoints } from '../../../config';

export type ApiReturn2<T = any> = {
  response: T | null;
  errors: ErrorMessage2[] | null;
  id?: number;
};

const getCandidateDetailsUrl = endpoints.candidateSignUp.getCandidateDetails;

export const getCandidateDetailsApi = async (apiErrorMessage: string): Promise<ApiReturn2> => {
  try {
    const config: AxiosRequestConfig = {
      params: {},
    };
    const res = await axios.get(getCandidateDetailsUrl, config);
    if (res.data.status === '1') {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: res.data.details,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    return {
      response: null,
      errors: [
        {
          errorType: 'BadRequest',
          fieldName: 'Generic',
          messageCode: apiErrorMessage
        },
      ],
    };
  }
};
